import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './account/core/guards/auth.guard';
import { AccessDeniedComponent } from './_shared/components/access-denied/access-denied.component';
import { PageNotFoundComponent } from './_shared/components/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: '404',
    component: PageNotFoundComponent,
  },
  {
    path: '403',
    component: AccessDeniedComponent,
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./_shared/_layout/layout.module').then(m => m.LayoutModule)
  },
  {
    path: '**',
    redirectTo: '404'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
